import React, {Fragment, useEffect, useState} from 'react';
import {Card, Col, Form, Row} from "react-bootstrap";
import {useFormContext, useWatch} from "react-hook-form";
import AdditionalInformationV2Point from "./AdditionalInformationV2Point";
import useQuery from "../../../invoice/form/useQuery";
import {
    loadSystemOrganizationAddressesAsync, selectSystemOrganizationAddresses
} from "../../../../../../app/store/reducers/roamingReference/roamingReferenceReducer";
import {useDispatch, useSelector} from "react-redux";
import {getWaybillRegionAsync} from "../../../../../../app/store/reducers/roaming/roamingWaybillV2Reducer";


export const LOADING_POINT = "loading_point"
export const UNLOADING_POINT = "unloading_point"

const AdditionalInformationV2 = ({isEditing, content, ediShipment}) => {
    const dispatch = useDispatch();
    const organizationAddresses = useSelector(selectSystemOrganizationAddresses);

    const {draft_waybill_id, waybill_id, shipment_id} = useQuery();

    const executorInnOrPinfl = useWatch({name:'executor.inn_or_pinfl', exact: true})
    const customerInnOrPinfl = useWatch({name:'customer.inn_or_pinfl', exact: true})
    const branchCode = useWatch({name:'branch_code', exact: true})

    useEffect(() => {
        dispatch(loadSystemOrganizationAddressesAsync());
        dispatch(getWaybillRegionAsync())
    }, []);

    return (
        <Fragment>
            <Row className={'my-3'}>
                <Col sm={12} md={6}>
                    <AdditionalInformationV2Point
                        pointName={LOADING_POINT}
                        inn={executorInnOrPinfl}
                        organizationAddresses={organizationAddresses.filter(item => item.contractor_inn === executorInnOrPinfl)}
                        title={'roaming.waybill.v2.send.loading_point.title'}
                        isEditing={isEditing || draft_waybill_id || waybill_id || shipment_id}
                        content={content}
                        ediShipment={ediShipment}
                    />
                </Col>

                <Col sm={12} md={6}>
                    <AdditionalInformationV2Point
                        pointName={UNLOADING_POINT}
                        inn={customerInnOrPinfl}
                        title={'roaming.waybill.v2.send.unloading_point.title'}
                        organizationAddresses={organizationAddresses}
                        customer={customerInnOrPinfl}
                        isEditing={isEditing || draft_waybill_id || waybill_id || shipment_id}
                        content={content}
                        brachCode={branchCode}
                        ediShipment={ediShipment}
                    />
                </Col>
            </Row>
        </Fragment>
    );
};

export default AdditionalInformationV2;
